import React from 'react';
import { MapPin, PhoneCall, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="bg-[#0B1220] py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 grid gap-10 lg:grid-cols-2 lg:gap-12 items-center">
        <div>
          <div className="flex items-center gap-3 text-[#F59E0B]">
            <span className="h-[2px] w-8 bg-[#F59E0B]" />
            <span className="text-[11px] font-bold tracking-[0.25em]">CONTACT US</span>
          </div>
          <h2 className="mt-5 text-white font-extrabold tracking-tight leading-[1.05]" style={{ fontSize: 'clamp(2rem, 4.2vw, 3.5rem)' }}>
            Visit our ACE MONEY EXCHANGE branch today
          </h2>

          <div className="mt-10 space-y-8">
            <div className="flex items-start gap-5">
              <div className="w-11 h-11 rounded-lg bg-[#F59E0B]/15 flex items-center justify-center flex-shrink-0">
                <MapPin className="w-5 h-5 text-[#F59E0B]" />
              </div>
              <div>
                <div className="font-bold text-white">Our Address</div>
                <div className="mt-1 text-slate-400">Tridevi Sadak, between Gambeshi Dohori Nach Ghar and Columbia clothing store, Thamel, Kathmandu 44600</div>
              </div>
            </div>
            <div className="flex items-start gap-5">
              <div className="w-11 h-11 rounded-lg bg-[#F59E0B]/15 flex items-center justify-center flex-shrink-0">
                <PhoneCall className="w-5 h-5 text-[#F59E0B]" />
              </div>
              <div>
                <div className="font-bold text-white">Phone &amp; Email</div>
                <div className="mt-1 text-slate-400">
                  <a href="tel:+97714412345" className="hover:text-[#F59E0B] transition-colors">+977-1-4412345</a>
                  {' / '}
                  <a href="mailto:info@acemoneyexchange.com.np" className="hover:text-[#F59E0B] transition-colors">info@acemoneyexchange.com.np</a>
                </div>
              </div>
            </div>
            <div className="flex items-start gap-5">
              <div className="w-11 h-11 rounded-lg bg-[#F59E0B]/15 flex items-center justify-center flex-shrink-0">
                <Clock className="w-5 h-5 text-[#F59E0B]" />
              </div>
              <div>
                <div className="font-bold text-white">Opening Hours</div>
                <div className="mt-1 text-slate-400">Everyday: 8:00 AM - 8:00 PM</div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto">
          <iframe
            title="Ace Money Exchange location on Google Maps"
            src="https://www.google.com/maps?cid=11953928543198322698&output=embed"
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <a
            href="https://www.google.com/maps/place/Ace+Money+Exchange/@27.7144098,85.3132012,19.29z/data=!4m14!1m7!3m6!1s0x39eb1910506ec767:0xa5e4e2ace7bd200a!2sAce+Money+Exchange!8m2!3d27.7142048!4d85.313599!16s%2Fg%2F11zf605rkh!3m5!1s0x39eb1910506ec767:0xa5e4e2ace7bd200a!8m2!3d27.7142048!4d85.313599!16s%2Fg%2F11zf605rkh"
            target="_blank"
            rel="noopener noreferrer"
            className="absolute bottom-4 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 bg-[#F59E0B] hover:bg-[#E08D0A] text-slate-900 font-semibold text-sm px-4 py-2 rounded-full shadow-lg transition-colors"
          >
            <MapPin className="w-4 h-4" />
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
